import * as yup from 'yup'

const cssPercentageUnit = [...(['%'] as const)]
export type CssPercentageUnit = '%'

const cssAbsLengthUnit = [...(['px', 'cm', 'mm', 'q', 'in', 'pt', 'pc'] as const)]
export type CssAbsLengthUnit = 'px' | 'cm' | 'mm' | 'q' | 'in' | 'pt' | 'pc'

const cssRelativeLengthUnit = [...(['em', 'ex', 'ch', 'rem', 'vw', 'vh', 'vmin', 'vmax'] as const)]
export type CssRelativeLengthUnit = 'em' | 'ex' | 'ch' | 'rem' | 'vw' | 'vh' | 'vmin' | 'vmax'

const cssBorderStyleTypes = [
	...(['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'] as const),
]
export type CssBorderStyleTypes =
	| 'none'
	| 'hidden'
	| 'dotted'
	| 'dashed'
	| 'solid'
	| 'double'
	| 'groove'
	| 'ridge'
	| 'inset'
	| 'outset'

export const cssLength = yup
	.object({
		unit: yup
			.mixed<CssAbsLengthUnit | CssRelativeLengthUnit>()
			.oneOf([...cssAbsLengthUnit, ...cssRelativeLengthUnit]),
		value: yup.number(),
	})
	.noUnknown()

export const cssUnitValue = yup
	.object({
		unit: yup
			.mixed<CssPercentageUnit | CssAbsLengthUnit | CssRelativeLengthUnit>()
			.oneOf([...cssPercentageUnit, ...cssAbsLengthUnit, ...cssRelativeLengthUnit]),
		value: yup.number(),
	})
	.noUnknown()

export const cssBorderWidth = yup
	.object({
		top: cssLength.required(),
		right: cssLength.required(),
		bottom: cssLength.required(),
		left: cssLength.required(),
	})
	.noUnknown()

const cssBrStyle = yup.mixed<CssBorderStyleTypes>().oneOf(cssBorderStyleTypes)

export const cssBorderStyle = yup
	.object({
		top: cssBrStyle.required(),
		right: cssBrStyle.required(),
		bottom: cssBrStyle.required(),
		left: cssBrStyle.required(),
	})
	.noUnknown()

const cssByte = yup.number().min(0).max(255)

export const cssColor = yup
	.object({
		red: cssByte.required(),
		green: cssByte.required(),
		blue: cssByte.required(),
		alpha: yup.number().min(0).max(1).required(),
	})
	.noUnknown()

export const cssBorderColor = yup
	.object({
		top: cssColor.required(),
		right: cssColor.required(),
		bottom: cssColor.required(),
		left: cssColor.required(),
	})
	.noUnknown()

export const boxShadowDefinition = yup
	.object({
		inset: yup.boolean(),
		offsetX: cssLength,
		offsetY: cssLength,
		blurRadius: cssLength,
		spreadRadius: cssLength,
		color: cssColor,
	})
	.noUnknown()

export const cssBorder = yup
	.object({
		width: cssBorderWidth.required(),
		style: cssBorderStyle.required(),
		color: cssBorderColor.required(),
	})
	.noUnknown()

export const cssBorderRadius = yup.object({
	topLeft: cssUnitValue,
	topRight: cssUnitValue,
	bottomRight: cssUnitValue,
	bottomLeft: cssUnitValue,
})

export const cssBoxShadow = yup.array().of(boxShadowDefinition).min(1)

export const cssStyle = yup.object({
	cssBorder: cssBorder.default(undefined),
	cssBoxShadow: cssBoxShadow.default(undefined),
	cssBorderRadius: cssBorderRadius.default(undefined),
})
